(function () {
  // IIFE to prevent global leakage

  var env = window.location.origin.indexOf('hubspotqa') >= 0 ? 'qa' : 'prod';
  var headElement = document.getElementsByTagName('head')[0];
  var lifecycleQueue = (window.hsQueuedLifecycleTimestamps = {});
  var urlRewriteRules = null;
  var hsHasHubspotDlbLoaded = false;
  var postDlbLoadedCallbacks = [];

  var PREVIEW_DOMAINS = {
    local: 'local.hubspotqa',
    prod: 'preview.hs-sites',
    qa: 'preview.hs-sitesqa',
  };

  if (
    // Cookie that is set internally in prepareAppSession
    document.cookie.includes('hs_selenium') ||
    // Fallback to checking for query string
    window.location.href.indexOf('seleniumRunning') > -1
  ) {
    window.SELENIUM_IS_RUNNING = true;
  }

  try {
    var urlRewriteString = window.localStorage.getItem('URL_REWRITE');
    if (urlRewriteString) {
      urlRewriteJSON = JSON.parse(urlRewriteString);
      urlRewriteRules = [];

      for (var i = 0; i < urlRewriteJSON.length; i++) {
        var re = new RegExp(urlRewriteJSON[i][0], 'ig');
        urlRewriteRules.push([re, urlRewriteJSON[i][1]]);
      }
    }
  } catch (e) {
    console.error(e);
  }

  function appendToHead(element) {
    headElement.appendChild(element);
  }

  function loadScript(path) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.crossorigin = 'anonymous';
    script.src = hubspot.bender.staticDomain + path;

    // Per https://www.html5rocks.com/en/tutorials/speed/script-loading/ force injected scripts to
    // maintain order ()
    script.async = false;

    appendToHead(script);
  }

  function preloadJS(path) {
    var link = document.createElement('link');
    var isPreloadSupported =
      link.relList && link.relList.supports && link.relList.supports('preload');

    // Firefox doesn't support preload yet, so use prefetch as next best choice
    link.rel = isPreloadSupported ? 'preload' : 'prefetch';
    link.href = hubspot.bender.staticDomain + path;
    link.as = 'script';

    appendToHead(link);
  }

  window.runHubSpotDlbLoadedCallbacks = function () {
    hsHasHubspotDlbLoaded = true;
    postDlbLoadedCallbacks.forEach(function (callback) {
      callback();
    });
  };

  window.executeAfterHubspotDlbLoaded = function (callback) {
    if (hsHasHubspotDlbLoaded) {
      callback();
    } else {
      postDlbLoadedCallbacks.push(callback);
    }
  };

  function queueUpLifecycle(lifecycleName, timestamp) {
    lifecycleQueue[lifecycleName] = timestamp;
  }

  function markAndQueueUpLifecycle(lifecycleName) {
    queueUpLifecycle(lifecycleName, window.performance.now());

    if (window.performance.mark) {
      window.performance.mark(lifecycleName);
    }
  }

  function rewriteUrl(url) {
    if (urlRewriteRules) {
      try {
        for (var i = 0; i < urlRewriteRules.length; i++) {
          url = url.replace(urlRewriteRules[i][0], urlRewriteRules[i][1]);
        }
      } catch (e) {
        console.error(e);
      }
    }

    return url;
  }

  function apiUrl(endpoint) {
    var url = window.quickFetch.getApiUrl('/' + endpoint, false);
    var newUrl = rewriteUrl(url);
    if (newUrl != url) {
      return newUrl;
    }

    return window.quickFetch.getApiUrl('/' + endpoint, true);
  }

  function serializeValue(key, value) {
    var valueToEncode = value == null ? '' : value;
    return encodeURIComponent(key) + '=' + encodeURIComponent(valueToEncode);
  }

  function serializeArray(key, value) {
    return value
      .reduce(function (result, current) {
        // mimic the default jQuery behavior here
        if (current != null) {
          result.push(serializeValue('' + key, current));
        }
        return result;
      }, [])
      .join('&');
  }

  function stringify(query) {
    if (query == null) return '';
    if (typeof query === 'string' || query instanceof String) return query;
    return Object.keys(query)
      .reduce(function (result, key) {
        const value = query[key];
        if (Array.isArray(value)) {
          if (value.length > 0) result.push(serializeArray(key, value));
        } else if (value != null) {
          result.push(serializeValue(key, value));
        }
        return result;
      }, [])
      .join('&');
  }
  // end functions copied from https://git.hubteam.com/HubSpot/hub-http/blob/master/static/js/helpers/params.js

  function useLocalAssets() {
    return (
      enviro.getShort('preview_asset') === 'local' ||
      !enviro.deployed('content')
    );
  }

  function getPreviewAppDomain() {
    if (useLocalAssets()) {
      return document.location.origin;
    }
    return;
  }

  function getPreviewBranchPreviewBuild() {
    // Pass along the current branch preview build ID If it exists (e.g `b-*.dynamic.hsappstatic.net`)
    if (hubspot.bender.staticDomain.indexOf('dynamic.hsappstatic.net') >= 0) {
      return hubspot.bender.staticDomain.split(/b-|\./g)[1];
    }
    return;
  }

  function jqueryStaticVersion() {
    return window.hubspot.bender.depVersions['jquery'];
  }

  function jQueryJsUrl() {
    return '/jquery/' + jqueryStaticVersion() + '/index.js';
  }

  // Track how long it took for the document to download (if available)
  if (
    window.performance.timing &&
    window.performance.timing.responseEnd &&
    window.performance.timing.navigationStart
  ) {
    queueUpLifecycle(
      'PARENT_DOCUMENT_RESPONSE_FINISHED',
      window.performance.timing.responseEnd -
        window.performance.timing.navigationStart
    );
  }

  function getDLBScriptInjectParams(packageName) {
    var benderGlobal = window.hubspot.bender;

    // Note: If you want to run a _production_ mode build locally, you should force this dlbScriptName to be `bundle.production.js` to avoid a runtime error
    var dlbScriptName = useLocalAssets()
      ? 'bundle.development.js'
      : 'bundle.production.js';
    var dlbScriptInjectParams = [
      packageName, // projectName
      dlbScriptName, // file path
      false, // local (boolean)
      benderGlobal.depVersions[packageName], // version
    ].join(',');

    return dlbScriptInjectParams;
  }

  // Pull the correct env hubspot-dlb script to use in the iframe app from the parent
  function getHubSpotDLBScriptInjectParams() {
    return getDLBScriptInjectParams('hubspot-dlb');
  }

  function getReactDLBScriptInjectParams() {
    return getDLBScriptInjectParams('react-dlb');
  }

  function getHeadDLBScriptInjectParams() {
    return getDLBScriptInjectParams('head-dlb');
  }

  function getTinyMceDLBScriptInjectParams() {
    return getDLBScriptInjectParams('tinymce-dlb');
  }

  // "Exporting" via globals to app-specific early requester files
  window.hubspot = window.hubspot || {};
  window.hubspot.earlyUtils = {
    env: env,
    loadScript: loadScript,
    preloadJS: preloadJS,
    markAndQueueUpLifecycle: markAndQueueUpLifecycle,
    apiUrl: apiUrl,
    stringify: stringify,
    useLocalAssets: useLocalAssets,
    getPreviewAppDomain: getPreviewAppDomain,
    getPreviewBranchPreviewBuild: getPreviewBranchPreviewBuild,
    jQueryJsUrl: jQueryJsUrl,
    getHubSpotDLBScriptInjectParams: getHubSpotDLBScriptInjectParams,
    getReactDLBScriptInjectParams: getReactDLBScriptInjectParams,
    getHeadDLBScriptInjectParams,
    getTinyMceDLBScriptInjectParams,
  };
})();




const earlyUtils = window.hubspot.earlyUtils;

const OPTIN_NAME = 'patagonia-redesign-user-test';

function parseEditorUrl() {
  const matches = window.location.pathname.match(
    /knowledge-article\/(\d+)\/(\w+)\/(\d+)?\/?(\w+)?/
  );

  return {
    portalId: matches[1],
    subpath: matches[2],
    // articleId is synonymous with hubDbRowId
    articleId: matches[3],
  };
}

const { articleId, portalId, subpath } = parseEditorUrl();
const route = subpath || 'content';

const isShowingPreview = route !== 'settings' && route !== 'publishing';
let injectedBundles = false;

const PREVIEW_DOMAINS = {
  /* eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils */
  local: 'local.hubspotqa.com',
  prod: 'preview.hs-sites.com',
  qa: 'preview.hs-sitesqa.com',
};

function getPreviewUrl(
  previewDomain,
  previewKey,
  hubDbRowId,
  contentId,
  themeVariant
) {
  const benderPackage = 'knowledge-base-inpage-editor-ui';
  const params = {
    _preview: true,
    appDomain: earlyUtils.getPreviewAppDomain(),
    benderPackage,
    branchPreviewBuild: earlyUtils.getPreviewBranchPreviewBuild(),
    cacheBust: Date.now(),
    cssPath: 'bundles/app.css',
    inpageEditorUI: true,
    localAssets: earlyUtils.useLocalAssets(),
    portalId,
    preview_key: previewKey,
    scriptPath: 'bundles/app.js',
    staticVersion: window.hubspot.bender.depVersions[benderPackage],
    preview_theme: true,
    env: window.location.hostname.indexOf('hubspotqa.com') >= 0 ? 'qa' : 'prod',
    injectedScripts: [
      earlyUtils.getHubSpotDLBScriptInjectParams(),
      earlyUtils.getReactDLBScriptInjectParams(),
      earlyUtils.getHeadDLBScriptInjectParams(),
    ],
    hsSmartContentDefault: true,
    hsEditorApp: 'page',
    hubdb_row_id: hubDbRowId,
  };

  if (themeVariant) {
    params.theme_variant = themeVariant;
  }

  if (window.SELENIUM_IS_RUNNING) {
    params.seleniumRunning = true;
  }

  return `https://${previewDomain}/_hcms/preview/content/${contentId}?${earlyUtils.stringify(
    params
  )}`;
}

function getSidebarIframeUrl(previewDomain, previewKey, contentId) {
  const benderPackage = 'InpageEditorUI';
  const params = {
    portalId,
    _preview: true,
    preview_key: previewKey,
    inpageEditorUI: true,
    benderPackage,
    branchPreviewBuild: earlyUtils.getPreviewBranchPreviewBuild(),
    staticVersion: window.hubspot.bender.depVersions[benderPackage],
    cssPath: 'bundles/app.css',
    localAssets: earlyUtils.useLocalAssets(),
  };
  if (window.SELENIUM_IS_RUNNING) {
    params.seleniumRunning = true;
  }

  return `https://${previewDomain}/_hcms/preview/content/${contentId}/sidebar?${earlyUtils.stringify(
    params
  )}`;
}

function findSkeleton() {
  return document.querySelector('.patagonia-skeleton');
}

function findPreviewIframeWrapper() {
  return document.querySelector('.preview-iframe-wrapper');
}

function findPreviewFrameElement() {
  return document.querySelector('#contentEditor-preview');
}

function findSidebarFrameElement() {
  return document.querySelector('#contentEditor-sidebar');
}

function findSidebarIframeWrapper() {
  return document.querySelector('.sidebar-iframe-wrapper');
}

function setupIframeUrlGlobals(
  previewDomain,
  previewKey,
  hubDbRowId,
  contentId,
  themeVariant
) {
  window.hsPreviewDomain = previewDomain;
  window.hsPreviewIframeUrl = getPreviewUrl(
    previewDomain,
    previewKey,
    hubDbRowId,
    contentId,
    themeVariant
  );
  window.hsSidebarIframeUrl = getSidebarIframeUrl(
    previewDomain,
    previewKey,
    contentId
  );
}

function hideEverything() {
  findSkeleton().style.display = 'none';
  findPreviewIframeWrapper().style.display = 'none';
  findSidebarIframeWrapper().style.display = 'none';
}

function earlyLoadPreviewIframe() {
  // Make sure the iframe's parent container is visible
  findPreviewIframeWrapper().style.display = 'block';

  const iframe = findPreviewFrameElement();
  // Only set the src if we beat the react tree
  if (iframe && !iframe.src) {
    // setupIframeUrlGlobals must have been already called
    iframe.src = window.hsPreviewIframeUrl;
    iframe.addEventListener('load', () => {
      window.hsPreviewIframeLoaded = true;
    });
    earlyUtils.markAndQueueUpLifecycle('PREVIEW_IFRAME_STARTED');

    // Saving the iframe start timestamp so the the app's JS can fill it in to the
    // window.SELENIUM_APP_STATE.startIframeReload later
    window.hsPreviewIframeStartTimestamp = Date.now();
  }
}

function earlyLoadSidebarIframe() {
  const iframe = findSidebarFrameElement();
  // Only set the src if we beat the react tree
  if (iframe && !iframe.src) {
    // setupIframeUrlGlobals must have been already called
    iframe.src = window.hsSidebarIframeUrl;
    iframe.addEventListener('load', () => {
      window.hsSidebarIframeLoaded = true;
    });
    earlyUtils.markAndQueueUpLifecycle('SIDEBAR_IFRAME_STARTED');
  }
}

function setUpPatagoniaSkeleton() {
  const sidebarIframe = findSidebarFrameElement();
  const previewIframe = findPreviewFrameElement();
  const previewIframeWrapper = findPreviewIframeWrapper();
  const sidebarIframeWrapper = findSidebarIframeWrapper();
  sidebarIframeWrapper.classList.add('patagonia');
  sidebarIframe.setAttribute(
    'class',
    'clean-iframe patagonia-contentEditor-sidebar'
  );
  previewIframeWrapper.classList.add('patagonia');
  previewIframe.classList.add('patagonia-preview');
}

function editorStaticVersion() {
  return window.hubspot.bender.depVersions['knowledge-base-editor-ui'];
}

function editorAppJsUrl() {
  return `/knowledge-base-editor-ui/${editorStaticVersion()}/bundles/project.js`;
}

function preloadJsBundles() {
  earlyUtils.preloadJS(earlyUtils.jQueryJsUrl());
  earlyUtils.preloadJS(editorAppJsUrl());
}

function injectJsBundles() {
  if (!injectedBundles) {
    injectedBundles = true;

    preloadJsBundles();

    // Ensure that we don't inject our JS bundles before the DLB has been encountered/run in the Head.
    // More info in https://hubspot.slack.com/archives/C4ABAB8CR/p1582208888376800?thread_ts=1582199445.373700&cid=C4ABAB8CR
    window.executeAfterHubspotDlbLoaded(() => {
      earlyUtils.markAndQueueUpLifecycle('PARENT_APP_JS_INJECTED');
      earlyUtils.loadScript(earlyUtils.jQueryJsUrl());
      earlyUtils.loadScript(editorAppJsUrl());
    });
  }
}

// Add route class name to adjust app skelton per route
document.body.classList.add(`initial-pages-route-${route}`);

function loadIframe(isSecondAttempt, contentId, hubDbRowId, themeVariant) {
  let previewKeyUrl;
  if (window.hsUsePreviewInfoEndpoint) {
    previewKeyUrl = earlyUtils.apiUrl(
      `content-editor/v1/preview-info/${contentId}`
    );
  } else {
    previewKeyUrl = earlyUtils.apiUrl(
      `content-editor/v1/preview-key/${contentId}`
    );
  }
  let previewKeyEarlyRequestId = `preview-key-${contentId}`;
  if (isSecondAttempt) {
    // Add a cache-buster on the second attempt
    previewKeyUrl += `?t=${Date.now()}`;
    previewKeyEarlyRequestId += '-retry';
  }

  window.quickFetch.makeEarlyRequest(previewKeyEarlyRequestId, {
    contentType: 'application/json',
    dataType: 'json',
    timeout: 15000,
    type: 'GET',
    url: previewKeyUrl,
    whenFinished(resp) {
      let previewDomain;
      if (window.hsUsePreviewInfoEndpoint) {
        // Track when the preview key API finished when early requested
        earlyUtils.markAndQueueUpLifecycle('PREVIEW_KEY_REQUEST_FINISHED');
        previewDomain = resp && resp.previewDomain;
      } else {
        // Track when the preview info API finished when early requested
        earlyUtils.markAndQueueUpLifecycle('PREVIEW_INFO_REQUEST_FINISHED');
        previewDomain = PREVIEW_DOMAINS[earlyUtils.env];
      }

      const previewKey = resp && resp.previewKey;
      const earlyAuthFetch =
        window.quickFetch &&
        window.quickFetch.getRequestStateByName('api-verify');

      if (previewDomain && previewKey) {
        setupIframeUrlGlobals(
          previewDomain,
          previewKey,
          hubDbRowId,
          contentId,
          themeVariant
        );
        earlyLoadPreviewIframe();
        earlyLoadSidebarIframe();
      }

      if (earlyAuthFetch) {
        // whenFinished will immediately call the callback with the response
        // if the request has already completed
        earlyAuthFetch.whenFinished((authData) => {
          injectJsBundles();
          // set up patagonia sidebar iframe

          window.quickFetch.makeEarlyRequest(OPTIN_NAME, {
            url: window.quickFetch.getApiUrl(
              `/optins/v1/availability/${OPTIN_NAME}`
            ),
            timeout: 15000,
            dataType: 'json',
            contentType: 'application/json',
            type: 'GET',
            whenFinished(availability) {
              const isOptedInPatagonia = availability.state === 'OPTED_IN';

              const gates = authData.portal.enabled_gates;

              if (
                gates.includes('ContentEditorUI:PatagoniaRedesign') &&
                isOptedInPatagonia
              ) {
                setUpPatagoniaSkeleton();
              }
            },
          });
        });

        earlyAuthFetch.onError(() => {
          // If the early auth endpoint fails, fallback to injecting the app's JS to make sure
          // hub-http will force a redirect to the login page
          injectJsBundles();
        });
      } else {
        injectJsBundles();
      }
    },

    // If the preview-key endpoint fails, fallback to injecting the app's JS and loading the
    // iframe later
    onError() {
      if (!isSecondAttempt && !window.hsUsePreviewInfoEndpoint) {
        loadIframe(true);
      } else {
        injectJsBundles();
      }
    },
  });
}

function fetchInstanceLayoutPageAndLoadIframe(authData) {
  window.quickFetch.makeEarlyRequest('instanceLayoutPage', {
    contentType: 'application/json',
    dataType: 'json',
    timeout: 30000,
    type: 'GET',
    url: earlyUtils.apiUrl(
      `hubdb-content/v1/layout-pages/knowledge-article/${articleId}`
    ),
    whenFinished(instanceLayoutPage) {
      const contentId = instanceLayoutPage.id;
      const knowledgeBaseId = instanceLayoutPage.contentGroupId;
      const hubDbRowId = articleId;

      window.quickFetch.makeEarlyRequest('knowledgeBase', {
        contentType: 'application/json',
        dataType: 'json',
        timeout: 30000,
        type: 'GET',
        url: earlyUtils.apiUrl(
          `knowledge-content/v2/knowledge-base/${knowledgeBaseId}`
        ),
        whenFinished(knowledgeBase) {
          const themeVariant = authData.portal.enabled_gates.includes(
            'KnowledgeBaseV3:ThemeSettingsVariant'
          )
            ? knowledgeBase.values.hs_id
            : knowledgeBase.values.hs_theme_settings_id;

          // Save the iframe urls for later usage, just in case the preview-key API fails or specific route
          // that doesn't show the iframes is loaded
          setupIframeUrlGlobals(
            PREVIEW_DOMAINS[earlyUtils.env],
            'PREVIEW_KEY_PLACEHOLDER',
            hubDbRowId,
            contentId,
            themeVariant
          );

          let urlPath = `content-editor/v1/combined-edit-data/${contentId}?hsEditorApp=page`;

          if (themeVariant) {
            urlPath += `&variantName=${themeVariant}`;
          }

          window.quickFetch.makeEarlyRequest('content', {
            contentType: 'application/json',
            dataType: 'json',
            timeout: 30000,
            type: 'GET',
            url: earlyUtils.apiUrl(urlPath),
            whenFinished() {
              // Track when the combined-edit-data API finished when early requested
              earlyUtils.markAndQueueUpLifecycle(
                'COMBINED_EDIT_REQUEST_FINISHED'
              );
            },
          });

          window.quickFetch.makeEarlyRequest('customModules', {
            contentType: 'application/json',
            dataType: 'json',
            type: 'GET',
            url: earlyUtils.apiUrl(
              `designmanager/v1/modules/combined?limit=500&property=!source&contentId=${contentId}`
            ),
            whenFinished(results) {
              // Track when the custom module schemas API finishes when early requested, assuming we don't
              // need to fetch any more pages
              const nextOffset = results.offset + results.limit;

              if (!results.objects.length || results.total <= nextOffset) {
                earlyUtils.markAndQueueUpLifecycle(
                  'CUSTOM_MODULE_SCHEMA_REQUEST_FINISHED'
                );
              }
            },
          });

          // This is a hack to get around the fact that a lot of app code requires this to exist and return a content id.
          window.hubspot.parseEditorUrl = () => ({
            contentId,
            subpath,
            hubDbRowId,
          });

          loadIframe(false, contentId, hubDbRowId, themeVariant);
        },
      });
    },
    onError() {
      injectJsBundles();
      hideEverything();
    },
  });
}

function start(authData) {
  // Don't early fetch the iframe if the customer is going to the settings or publish tab
  if (!isShowingPreview) {
    injectJsBundles();
  } else {
    // Preload the JS bundles now, since we are dynamically injecting later after early requests
    // and it isn't actually in the HTML originally delivered
    preloadJsBundles();

    fetchInstanceLayoutPageAndLoadIframe(authData);

    if (window.hsUsePreviewInfoEndpoint) {
      earlyUtils.markAndQueueUpLifecycle('PREVIEW_INFO_REQUEST_STARTED');
    } else {
      earlyUtils.markAndQueueUpLifecycle('PREVIEW_KEY_REQUEST_STARTED');
    }
  }

  window.quickFetch.makeEarlyRequest('globalModules', {
    contentType: 'application/json',
    dataType: 'json',
    type: 'GET',
    url: earlyUtils.apiUrl('designmanager/v1/widgets/list-summaries'),
    whenFinished() {
      // Track when the global module schema API finishes when early requested
      earlyUtils.markAndQueueUpLifecycle(
        'GLOBAL_MODULE_SCHEMA_REQUEST_FINISHED'
      );
    },
  });

  window.quickFetch.makeEarlyRequest('initial-portal-scopes-fetch', {
    contentType: 'application/json',
    dataType: 'json',
    type: 'GET',
    url: earlyUtils.apiUrl(
      `hubs2/v1/scopes/hub/${portalId}/filter` +
        `?scopes=scopes=landingpages-access&scopes=sitepages-access&scopes=blog-access&scopes=landingpages-schedule&scopes=pages-schedule&scopes=blog-schedule&scopes=content-ab-testing&scopes=content-mab-testing`
    ),
  });

  window.quickFetch.makeEarlyRequest(
    'initial-account-verification-status-fetch',
    {
      contentType: 'application/json',
      dataType: 'json',
      type: 'GET',
      url: earlyUtils.apiUrl(
        'vetting/public/v2/account-verification/state/scope/landingpages-trusted'
      ),
    }
  );

  // Note, keep in sync with ALL_USER_ATTRIBUTE_KEYS_IN_DATABASE_AND_SUPERSTORE (will throw an error on load if they
  // don't match)
  window.hubspot.SHARED_EDITOR_USER_ATTRIBUTES_QUICK_FETCHED = {
    keys: [],
  };

  earlyUtils.markAndQueueUpLifecycle('COMBINED_EDIT_REQUEST_STARTED');
  earlyUtils.markAndQueueUpLifecycle('CUSTOM_MODULE_SCHEMA_REQUEST_STARTED');
  earlyUtils.markAndQueueUpLifecycle('GLOBAL_MODULE_SCHEMA_REQUEST_STARTED');
}

const earlyAuthFetch =
  window.quickFetch && window.quickFetch.getRequestStateByName('api-verify');

if (earlyAuthFetch) {
  // whenFinished will immediately call the callback with the response
  // if the request has already completed
  earlyAuthFetch.whenFinished((authData) => {
    const gates = authData.portal.enabled_gates;

    if (gates.includes('KnowledgeBase:V3.1')) {
      start(authData);
    } else {
      hideEverything();
      injectJsBundles();
    }
  });

  earlyAuthFetch.onError(() => {
    hideEverything();
    injectJsBundles();
  });
}


